import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from "react";
import CheckMarkIcon from "./CheckMarkIcon";
import * as S from "./styles";
export var AddToCartButton = function AddToCartButton(_ref) {
  var t = _ref.addedToCart,
      e = _ref.onAddClick;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      a = _useState2[0],
      r = _useState2[1],
      _useState3 = useState(!1),
      _useState4 = _slicedToArray(_useState3, 2),
      o = _useState4[0],
      d = _useState4[1],
      c = "Add to cart",
      _useState5 = useState(c),
      _useState6 = _slicedToArray(_useState5, 2),
      n = _useState6[0],
      u = _useState6[1];

  return useEffect(function () {
    t && (u("Added to cart"), r(!0), d(!0), setTimeout(function () {
      r(!1), d(!1), u(c);
    }, 1500));
  }, [t]), React.createElement(S.Wrapper, {
    "data-testid": "pip-add-to-cart-button-control"
  }, React.createElement(S.AddToCartButton, {
    "data-testid": "pip-add-to-cart-button",
    appearance: "tertiary",
    onClick: function onClick(t) {
      t.preventDefault(), e();
    },
    disabled: o
  }, a && React.createElement(CheckMarkIcon, null), n));
};
export default AddToCartButton;